import { Entity, makeClone } from 'gossamer-unified';
import { Convo, ConvoRow } from './Convo';
import { ConvoUser } from './ConvoUser';

export interface ConvoUserViewRow extends ConvoRow {
  user_id: string;
  latest_read_message_id: number;
  latest_ntfd_message_id: number;
}

const clone = makeClone();

export const ConvoUserView: Entity<ConvoUserViewRow> = {
  id: 'ConvoUserView',
  title: 'Convo User View',
  service: 'main',
  rowLabel: (row: ConvoUserViewRow) => [row.id, row.user_id].join(' / '),
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.convo_user_view',
  },
  security: [
    {
      role: 'all-authed',
      action: 'read',
      access: 'conditional',
      condition: "user_id = '{userId}'",
    },
  ],
  defaultSort: Convo.defaultSort,
  defaultFilters: Convo.defaultFilters,
  listRowLink: Convo.listRowLink,
  fields: {
    id: clone(Convo.fields.id),
    subject_text: clone(Convo.fields.subject_text),
    institution_id: clone(Convo.fields.institution_id),
    forum_type: clone(Convo.fields.forum_type),
    forum_key: clone(Convo.fields.forum_key),
    latest_message_id: clone(Convo.fields.latest_message_id),
    latest_message_at: clone(Convo.fields.latest_message_at),
    recipient_user_id: clone(Convo.fields.recipient_user_id),
    created_by: clone(Convo.fields.created_by),
    created_at: clone(Convo.fields.created_at),
    user_id: clone(ConvoUser.fields.user_id, { listColumn: false }),
    latest_read_message_id: clone(ConvoUser.fields.latest_read_message_id),
    latest_ntfd_message_id: clone(ConvoUser.fields.latest_ntfd_message_id),
  },
};
